import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "project-task-modal" }
const _hoisted_2 = {
  key: 0,
  class: "project-task-modal__info-banner"
}
const _hoisted_3 = { class: "project-task-modal__section" }
const _hoisted_4 = {
  key: 0,
  class: "project-task-modal__error-text"
}
const _hoisted_5 = {
  key: 1,
  class: "project-task-modal__notifications"
}
const _hoisted_6 = { class: "project-task-modal__notifications-title" }
const _hoisted_7 = { class: "project-task-modal__notifications-optional" }
const _hoisted_8 = { class: "project-task-modal__notifications-hint" }
const _hoisted_9 = {
  key: 0,
  class: "project-task-modal__notifications-body"
}
const _hoisted_10 = { class: "project-task-modal__date-time-row" }
const _hoisted_11 = { class: "project-task-modal__field-label" }
const _hoisted_12 = { class: "project-task-modal__time-wrapper" }
const _hoisted_13 = { class: "project-task-modal__field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_exclamation = _resolveComponent("exclamation")!
  const _component_inputGroup = _resolveComponent("inputGroup")!
  const _component_iconChevronRight = _resolveComponent("iconChevronRight")!
  const _component_singleDatePicker = _resolveComponent("singleDatePicker")!
  const _component_hadrianSelect = _resolveComponent("hadrianSelect")!
  const _component_tagBox = _resolveComponent("tagBox")!
  const _component_hadrianModal = _resolveComponent("hadrianModal")!

  return (_openBlock(), _createBlock(_component_hadrianModal, {
    ref: "modal",
    title: _ctx.$t('projectTasks.modal.titleDetails'),
    rightButtonText: _ctx.isDetails ? _ctx.$t('projectTasks.modal.close') : _ctx.$t('projectTasks.modal.save'),
    leftButtonText: _ctx.isDetails ? _ctx.$t('projectTasks.modal.reopenTask') : _ctx.$t('projectTasks.modal.cancel'),
    isLoading: _ctx.isSaving,
    rightButtonDisabled: !_ctx.isDetails && (!_ctx.isFormValid || _ctx.isSaving),
    hideOnLeftClick: !_ctx.isDetails,
    onRightButtonClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDetails ? _ctx.hide() : _ctx.onSave())),
    onLeftButtonClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isDetails ? _ctx.enterRestoreMode() : _ctx.hide())),
    isForm: !_ctx.isDetails,
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.taskId && !_ctx.isDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_exclamation, { class: "project-task-modal__info-icon" }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('projectTasks.modal.infoBanner')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_inputGroup, {
              label: _ctx.$t('projectTasks.modal.titleLabel'),
              mandatory: !_ctx.isDetails,
              modelValue: _ctx.form.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
              maxLength: 90,
              showMaxLengthLabel: !_ctx.isDetails,
              disabled: _ctx.isDetails,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.titleError = false)),
              class: _normalizeClass({ 'project-task-modal__input--error': _ctx.titleError })
            }, null, 8, ["label", "mandatory", "modelValue", "showMaxLengthLabel", "disabled", "class"]),
            (_ctx.titleError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('projectTasks.modal.errors.titleRequired')), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_inputGroup, {
            label: _ctx.$t('projectTasks.modal.descriptionLabel'),
            modelValue: _ctx.form.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
            numLines: 3,
            maxLength: 750,
            showMaxLengthLabel: !_ctx.isDetails,
            disabled: _ctx.isDetails,
            onKeyup: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
          }, null, 8, ["label", "modelValue", "showMaxLengthLabel", "disabled"])
        ]),
        (!_ctx.isDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "project-task-modal__notifications-header",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleNotifications && _ctx.toggleNotifications(...args)))
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t('projectTasks.modal.notificationsTitle')) + " ", 1),
                  _createElementVNode("em", _hoisted_7, _toDisplayString(_ctx.$t('projectTasks.modal.optional')), 1)
                ]),
                _createVNode(_component_iconChevronRight, {
                  class: _normalizeClass(["project-task-modal__notifications-chevron", { 'project-task-modal__notifications-chevron--open': _ctx.notificationsExpanded }])
                }, null, 8, ["class"])
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('projectTasks.modal.notificationsHint')), 1),
              (_ctx.notificationsExpanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "project-task-modal__date-wrapper",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.positionCalendar && _ctx.positionCalendar(...args)))
                      }, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('projectTasks.modal.dateLabel')), 1),
                        _createVNode(_component_singleDatePicker, {
                          ref: "datePicker",
                          value: _ctx.form.dueDate,
                          disabledDates: _ctx.disabledDates,
                          placeholder: _ctx.$t('projectTasks.modal.datePlaceholder'),
                          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDateInput($event))),
                          onClearDate: _ctx.clearDate
                        }, null, 8, ["value", "disabledDates", "placeholder", "onClearDate"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('projectTasks.modal.timeLabel')), 1),
                        _createVNode(_component_hadrianSelect, {
                          class: "project-task-modal__time-select",
                          value: _ctx.form.dueTime,
                          options: _ctx.filteredTimeOptions,
                          getOptionKey: t => t,
                          getOptionLabel: t => t,
                          disabled: !_ctx.form.dueDate,
                          mandatory: false,
                          variant: "thin",
                          onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.dueTime = $event))
                        }, null, 8, ["value", "options", "getOptionKey", "getOptionLabel", "disabled"])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(['project-task-modal__cc', { 'project-task-modal__cc--disabled': !_ctx.form.dueDate }])
                    }, [
                      (_openBlock(), _createBlock(_component_tagBox, {
                        key: _ctx.ccTagBoxKey,
                        suggestionList: _ctx.ccSuggestionList,
                        allowCustom: false,
                        initialValues: _ctx.form.ccEmails,
                        label: _ctx.$t('projectTasks.modal.ccLabel'),
                        maxItemCount: _ctx.CC_LIMIT,
                        maxItemCountLabel: _ctx.$t('projectTasks.modal.ccMessage'),
                        onInputValues: _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.ccEmails = $event))
                      }, null, 8, ["suggestionList", "initialValues", "label", "maxItemCount", "maxItemCountLabel"]))
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], undefined, true),
    _: 1
  }, 8, ["title", "rightButtonText", "leftButtonText", "isLoading", "rightButtonDisabled", "hideOnLeftClick", "isForm"]))
}